<template>
  <div>

    <!-- transaction start -->
    <div class="transaction-area pt-4">

      <div class="container">
        <div class="balance-title text-center">
          <h6 class="mt-5">Welcome back {{ user.firstname }}!</h6>
        </div>
        <div v-show="orders.length == 0" class="alert alert-success" role="alert">
          No orders displayed? <br />Check the filter <i class="las la-filter"></i> and change the date range or the
          query to try to find some.
        </div>
        <div v-if="busy" class="d-flex justify-content-center">
          <div class="spinner-grow text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-show="orders.length > 0">
          <!-- {{ chartId }} {{ orders }} -->

          <bar-chart :id="chartId" :data="dataChart" :options="dataOptions" @navigate="navigate"></bar-chart>

        </div>

        <div class="section-title">

          <!-- <div class="row justify-content-center">
            <div class="col-md-6">
              <div class="search-container ">
                <input type="text" class="form-control search-input" placeholder="Search...">
              </div>
            </div>
          </div> -->

          <div class="row w-100pct justify-content-between align-items-center no-gutters" style="margin-left:3px;">
            <!-- <div class="col col-auto">
           
              <i class="la la-plus la-2x text-primary hover-cursor" @click="$router.push('/orders')" ></i>
            </div> -->
          
            <div class="col col-auto">
              <router-link to="/orders">
                <h3 class="title mb-0 underline-primary">{{ orders.length }} Orders ...</i></h3>
              </router-link>
            </div>
            <div class="col col-auto">
               <i class="fa fa-refresh fa-2x text-primary" @click="orders_load()"></i>
            </div>
            <!-- <div class="col col-auto text-right text-primary"><small class="">{{ selectionset.length }} orders</small>
            </div> -->
            <div class="col col-auto">
              <!-- <div class="single-checkbox-inner mr-4 float-right">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" id="orderwithvalue"
                    @click="orderwithvalue = !orderwithvalue">
                  <label class="form-check-label" for="orderwithvalue">
                    View All
                  </label>

                </div>
              </div> -->
              <p @click="showfilter = !showfilter">
                <i class="las la-filter la-2x text-primary hover-cursor"></i>
                <span class="hover-cursor">{{
                  query_options.find(o => o.id == query).label}}</span><br />
             
                <span v-if="date_at.startDate" class="small underline-primary hover-cursor">{{
                $moment(date_at.startDate).format("DD/MM/YY") }} - {{ $moment(date_at.endDate).format("DD/MM/YY")
                  }}&nbsp;<i class="fa fa-calendar "></i>
                </span>

              </p>
            </div>
          </div>
        </div>

        <div v-show="showfilter" class="highlight-container mb-3 px-4">
          <div class="row gx-5">
            <div class="col">
              <div class="menu-close">
                <i @click="showfilter = false; orders_load()"
                  class="la la-times text-success float-right hover-cursor"></i>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="px-3 col-12 col-sm-6 col-md-4">
              <b-form-group label-cols="12" label="Date" label-size="sm">
                <b-input-group>
                  <daterangepicker size="sm" ref="dateplaced" v-model="date_at" :opens="'center'"
                    :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                    :single-date-picker="'range'">
                  </daterangepicker>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" @click="
                      date_at = {
                        startDate: null,
                        endDate: null,
                      }
                      ">
                      <i class="la la-times"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="px-3 col-12 col-sm-6 col-md-4">
              <b-form-group label-cols="12" label="Query" label-size="sm">
                <treeselect placeholder="Select query..." v-model="query" :clearable="false" :options="query_options"
                  :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                  search-nested :disabled="readonly">
                  <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
                </treeselect>
              </b-form-group>
            </div>
            <div class="px-3 col-12 col-sm-6 col-md-4">
              <b-form-group label-cols="12" label="Your Ref / PO" label-size="sm" size="sm">
                <b-input-group>
                  <b-form-input v-model="yourref" :debounce="orders.debounce" placeholder="Your Ref" size="sm" trim>
                  </b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!yourref" @click="yourref = ''">
                      <i class="la la-times"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <!-- <div class="col-12 col-sm-6 col-md-4">
                  <b-form-group label-cols="12" label="Event" label-size="sm">
                    <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                      v-model="eventcode" :multiple="true" :clearable="true" :async="true"
                      :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                      :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-form-group>
                </div> -->

          </div>
        </div>

        <ul class="transaction-inner">
          <li @click="$router.push('/order?id=' + order.id)" class="ba-single-transaction"
            v-for="(order, index) in orders" :key="index">
            <div class="thumb" :style="' line-height: normal;'">
              <!-- <div class="circle-inner circle-inner-one"> -->
              <!-- :fill="fill" -->
              <vue-circle
                :progress="parseFloat(order.value) != 0 ? ((parseFloat(order.value) - parseFloat(order.remaining)) / parseFloat(order.value)) * 100 : 0"
                :size="60" :reverse="false" line-cap="round" empty-fill="rgba(0, 0, 0, .1)" :animation-start-value="0.0"
                :start-angle="0" insert-mode="append" :thickness="3" :show-percent="true"
                @vue-circle-progress="progress" @vue-circle-end="progress_end">
                <!-- <p>OK</p> -->
              </vue-circle>
              <!-- <img src="assets/img/icon/35.png" alt="img"> -->
            </div>

            <div class="details">
              <span class="small text-warning">GBP {{ order.value | currency('') }}</span>
              <h5>{{ order.yourref }} </h5>
              <p class="d-xs-450-none">{{ order.description }} </p>
              <h5 :class="parseFloat(order.remaining) >= 0 ? 'credit' : 'debit'" class="text-end mt-n23px">
                {{ order.remaining | currency('') }}
                <p class="pt-1"><i class="fa fa-arrow-circle-right text-light"></i></p>
              </h5>

            </div>
          </li>

        </ul>
      </div>
    </div>
    <!-- transaction End -->

    <!-- <div v-if="order.length>0" class="alert alert-danger" role="alert">
      No orders? Check the filter and adjust the date range or the query
    </div> -->

    <!-- balance start -->
    <div class="balance-area mg-top-30">
      <div class="container">

        <div class="balance-area-bg balance-area-bg-home">
          <div class="ba-balance-inner text-end align-self-center">
            <div class="icon">
              <i class="las la-pound-sign la-4x"></i>
              <!-- <img src="assets/img/icon/1.png" alt="img"> -->
            </div>
            <h5 class="title">Order Balance</h5>
            <!-- <h5 class="amount">GBP {{orders.reduce((sum, item) => (sum + parseFloat(item.remaining)),
              0).toFixed(2) | currency('')}}</h5> -->
            <h5 :class="parseFloat($store.state.balance) >= 0 ? 'credit' : 'debit'">GBP {{ $store.state.balance }}</h5>
          </div>
        </div>
      </div>
    </div>
    <!-- balance End -->

  </div>
</template>

<script>
import VueCircle from 'vue2-circle-progress'

import shortid from "shortid";
import gql from "graphql-tag";


export default {
  components: {
    VueCircle,
  },
  name: "Home",
  data() {
    return {
      busy: false,
      readonly: false,
      showfilter: false,
      date_at: {
        startDate: this.$moment().add(-12,'months').format('YYYY-MM-DD'),
        endDate: this.$moment().add(3,'months').format('YYYY-MM-DD')
      },
      yourref: null,
      eventcode: [],
      query: "creditlimit",
      query_options: [
        { id: "*", label: "All Orders" },
        { id: "creditlimit", label: "Credit limited" },
        { id: "overspent", label: "Overspent" },
        // { id: "o", label: "Accumulated" },
      ],
      orders: [],
      chartId: shortid.generate(),
      dataChart: {
        labels: [],
        datasets: [
          { labels: [], backgroundColor: [], data: [] },
          { labels: [], backgroundColor: [], data: [] },
          { labels: [], backgroundColor: [], data: [] }
        ]
      },
      dataOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            }
          ]
        },
        tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var currentValue = dataset.data[tooltipItem.index];

              var name = ''
              switch (tooltipItem.datasetIndex) {
                case 0:
                  name = 'Spent'
                  break;
                case 1:
                  name = 'Remaining'
                  break;
                case 2:
                  name = 'Reclaim'
                  break;
              }

              // name = tooltipItem.datasetIndex == 0 ? 'Spent' : 'Remaining';
              return name + ' : ' + currentValue;
            }
          }
        },
        onClick: function (evt, item) {
          var activePoints = this.getElementsAtEvent(evt);
          var firstPoint = activePoints[0];
          console.log("bar click", evt, item, activePoints, firstPoint);
        }
      },
      orderwithvalue: true,
    }
  },
  async mounted() {
    await this.orders_load()
  },
  watch: {
    chartId: {
      async handler(newVal, oldVal) {
        await this.orders_load(0)
      }
    },
    async date_at() {
      await this.orders_load(0);
    },
    async yourref() {
      if (this.yourref) {
        this.date_at = {
          startDate: null,
          endDate: null
        }
      } else {
        this.date_at = {
          startDate: this.$moment().startOf('year').format('YYYY-MM-DD'),
          endDate: this.$moment().endOf('year').format('YYYY-MM-DD')
        }
      }
      await this.orders_load(0);
    },
    async query() {
      await this.orders_load(0);
    },
    async eventcode() {
      await this.orders_load(0);
    },
  },
  computed: {
    date_query() {
      return this.$moment(this.date_at.startDate).format('YYYY/MM/DD') + '-' + this.$moment(this.date_at.endDate).format('YYYY/MM/DD')
    }
  },
  methods: {
    balance_text(amount) {
      let v = parseFloat(amount)
      console.log(v)
      if (v == 0) {
        return ""
      }
      if (v > 0) {
        return "under"
      }
      if (v < 0) {
        return "over"
      }
    },
    async orders_load(offset, limit, page) {

      this.busy = false

      let state = {
        offset: 0,
        limit: 0,
      }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        dateplaced_at: [
          this.date_at.startDate,
          this.date_at.endDate,
        ],
        slac: this.user.slac,
        yourref: this.user.yourref,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        query: this.query,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query orders(
              $limit: Int
              $offset: Int
              $dateplaced_at: [String]
              $slac: String
              $yourref: String
              $eventcode: String
              $query: String
            ) {
              orders(
                limit: $limit
                offset: $offset
                dateplaced_at: $dateplaced_at
                slac: $slac
                yourref: $yourref
                eventcode: $eventcode
                query: $query
              ) {
                id
                yourref
                description
                value
                spent
                reclaim
                remaining
                slac
                placed_at
                eventcode
                eventname
                value
                spent
                credit
                remaining
                notify_limit
                rows
              }
            }
          `,
          variables,
        });

        this.orders = response.data.orders;

        // SET THE BALANCE IN THE STORE
        let balance = this.orders.reduce((sum, item) => (sum + parseFloat(item.remaining)), 0)
        this.$store.state.balance = balance.toFixed(2)

        await this.loadChart();

      } catch (error) {
        console.log(error);
      }
      this.busy = false
    },
    async loadChart() {

      this.busy = true
      this.dataChart.labels = []
      this.dataChart.datasets[0].type = 'bar'
      this.dataChart.datasets[0].order = 2
      this.dataChart.datasets[0].backgroundColor = []
      this.dataChart.datasets[0].data = []

      this.dataChart.datasets[1].type = 'bar'
      this.dataChart.datasets[1].order = 2
      this.dataChart.datasets[1].backgroundColor = []
      this.dataChart.datasets[1].data = []

      this.dataChart.datasets[2].type = 'line'
      this.dataChart.datasets[2].order = 1
      this.dataChart.datasets[2].backgroundColor = []
      this.dataChart.datasets[2].data = []

      for (var j = 0; j < this.orders.length; ++j) {
        let order = this.orders[j]
        this.dataChart.labels.push(order.yourref)

        this.dataChart.datasets[0].backgroundColor.push("#dc3545")
        this.dataChart.datasets[0].data.push(parseFloat(order.spent))

        this.dataChart.datasets[1].backgroundColor.push("#28a745")
        this.dataChart.datasets[1].data.push(parseFloat(order.remaining))

        this.dataChart.datasets[2].backgroundColor.push("#20a8d8")
        this.dataChart.datasets[2].data.push(parseFloat(order.reclaim))

      }

      console.log(this.dataChart)
      this.busy = false
    },
    progress(event, progress, stepValue) {
      // console.log(stepValue);
    },
    progress_end(event) {
      // console.log("Circle progress end");
    },
    navigate(yourref) {
      console.log('navigate to', yourref)
      return
    }
  }
}
</script>


<style></style>
